import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import store from "./store";
import { library, } from '@fortawesome/fontawesome-svg-core'
import { faUser, faTrash, faEdit, faBell, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { reverseValue } from './utils/helpers'

library.add(faUser, faTrash, faEdit, faBell, faDownload)

Vue.component('font-awesome-icon', FontAwesomeIcon)


const moment = require("moment")
Vue.config.productionTip = false;

// Libraries
Vue.filter("toCurrency", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter("numberFormat", function (value) {

  var formatter = new Intl.NumberFormat("en-US", {


  });

  return formatter.format(value);
});

Vue.filter("toISODate", function (value) {
  return moment(value).toLocaleString()
});

Vue.filter("fixDouble", function (value) {
  const nVal = parseFloat(value)
  if (value == null) {
    return 0;
  }
  return Math.round((nVal + Number.EPSILON) * 100) / 100;
});

Vue.filter("reverseValue", reverseValue);

Vue.use(VueRouter);
Vue.use(BootstrapVue);

// Vue Notification
import VueNativeNotification from 'vue-native-notification'

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

Vue.notification.requestPermission()
  .then(console.log)


// Socket IO
import VueSocketIO from 'vue-socket.io'

Vue.use(new VueSocketIO({
  debug: true,
  connection: process.env.VUE_APP_SERVER_URI,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  },
  options: { path: "/socket.io/" } //Optional options
}))


// eslint-disable-next-line no-console
new Vue({
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    notfyEvent: function (data) {
      this.$notification.show(data.title, {
        body: data.message,
        icon: process.env.VUE_APP_SERVER_URI + '/triangle.png',
        // image: 'http://localhost:8080/triangle.png',
        silent: false,
        vibrate: true
      }, {})
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");
